import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUnreadProject } from '../../hooks/useUnread';

/**
 * Rolled-up unread indicator for a project.
 *
 * Counts TASKS with unread activity, not comments: "3" means three things need
 * your attention, which is actionable. A comment count would inflate with a
 * single chatty thread and stop meaning anything.
 */
const ProjectUnreadDot = ({ projectId, className = '' }) => {
  const { t } = useTranslation();
  const { tasks, mentions } = useUnreadProject(projectId);

  if (mentions > 0) {
    return (
      <span
        title={t('unread.mention', { count: mentions })}
        className={`inline-flex items-center justify-center min-w-[16px] h-4 px-1 rounded-full bg-blue-500 text-white text-[10px] font-semibold leading-none ${className}`}
      >
        {mentions}
      </span>
    );
  }

  if (tasks > 0) {
    return (
      <span
        title={t('unread.project_activity', { count: tasks })}
        className={`inline-block w-1.5 h-1.5 rounded-full bg-blue-400 ${className}`}
      />
    );
  }

  return null;
};

export default ProjectUnreadDot;
